import ButtonComponent                                  from "./ButtonComponent"
import setTriKrama                                      from "../../../../api/Report/Kualitatif/set/TriKrama"
import KualContext                                      from "../context/KualContext"
import TerlaporPelaporApi                               from "../../../../api/Report/Kualitatif/get/TerlaporApi"
import CustomToast                                      from "../../../../widgets/toast"

import { useContext, useEffect, useState }              from "react"
import { dateToInt, getMonthYear }                      from "../../../../../helpers/default_helper"
import { Button, Col, FormGroup, Input, Label, ListGroup, ListGroupItem, Row }            from "reactstrap"
import { useForm }                                      from "react-hook-form"
import SelectPeriode from "./SelectPeriode"

var validation = {
    periode             : true, 
    data_pendukung      : true,
    jumlah_pegawai      : true,
    jumlah_peserta      : true,
    nip                 : true,
    nomor               : true,
    nrp                 : true,
    pengucap            : true,
    tahun               : true,
    tanggal_apel        : true,
}

const FormTriKrama = (props) => {

    const { 
        periode_context,
        set_periode_context
    }                                                   = useContext(KualContext.Context)
    const [pengucap, set_pengucap]                      = useState(null)
    const [checkValidation, setCheckValidation]         = useState(false)
    const [isClickedSubmit, setIsClickedSubmit]         = useState(false)
    const [lampiranNew, setLampiranNew]                 = useState([])
    const [loading, setLoading]                         = useState(false)

    const {
        setValue,
        register,
        watch,
    } = useForm()

    useEffect(() => {
        setValue("periode", periode_context)
    }, [periode_context])

    function onSubmit() {
        let schema = {
            periode         : periode_context,
            bulan           : parseInt(getMonthYear(periode_context)[1]),
            tahun           : parseInt(getMonthYear(periode_context)[0]),
            // tanggal_apel    : watch("tanggal_apel") != "" ? dateToInt(watch("tanggal_apel")) : 0,
            tanggal_apel    : watch("tanggal_apel") != "" ? watch("tanggal_apel") : 0,
            pengucap        : pengucap,
            nomor           : watch("nomor"),
            jumlah_pegawai  : watch("jumlah_pegawai"),
            jumlah_peserta  : watch("jumlah_peserta"),
            data_pendukung  : lampiranNew,
        }

        let dataKey         = ['periode','bulan','data_pendukung','jumlah_pegawai','jumlah_peserta','nomor','tahun','tanggal_apel']
        let validasi        = true

        if(pengucap == null) {
            validasi                = false
            validation['pengucap']  = false
        } else {
            validation['pengucap']  = true

            Object.keys(pengucap).forEach(function(key) {
                if (key != "employment_status" && key !== "class" && key !== "uuid" && key != "work_unit" && key !== "work_unit_id") {
                    if (pengucap[key] === "" ) {
                        validasi                = false
                        validation['pengucap']  = false
                    }
                }
            });
        }

        dataKey.map((item) => {
            if(schema[item] === "" || schema[item] === 0 || schema[item] === null || schema[item] === undefined || schema[item] === NaN || schema[item].length == 0){
                validasi          = false
                validation[item]  = false
            } else {
                validation[item]  = true
            }
        })

        setCheckValidation(true)

        if(!validasi){
            CustomToast("warning", "Lengkapi Form Terlebih Dahulu!")
        }else if(schema.data_pendukung.length === 0){
            CustomToast("warning", "Lengkapi Form Terlebih Dahulu!")
        }else{
            if(!isClickedSubmit) {
                setIsClickedSubmit(true)
                setTriKrama(schema, false).then(handleBack)
            }
        }
    }

    function onSubmitNihil() {
        let schema = {
            periode             : periode_context,
            bulan               : parseInt(getMonthYear(periode_context)[1]),
            tahun               : parseInt(getMonthYear(periode_context)[0]),
        }

        if(!isClickedSubmit) {
            setIsClickedSubmit(true)
            setTriKrama(schema, true).then(handleBack)
        }
    }

    function handleBack() {
        CustomToast("success", "Berhasil Simpan data")
        props.onBack()
    }

    const addLampiranNew = (val) => {
        if(val.length > 0) {
            setLampiranNew([...lampiranNew, val[0]])
        }
    }

    const removeLampiranNew = (val) => {
        let temp = lampiranNew.filter((item) => item != val)
        setLampiranNew(temp)
    }

    const renderLabel = (type, label) => {
        return(
            <Label className="col-12 p-0">
                <div class="d-flex justify-content-between">
                    <div>{label}</div>
                    <div>
                        {
                            !validation[type] ? (
                                <small class="text-danger mb-1" role="alert">
                                    {label} Wajib Diisi!
                                </small>
                            ) : null
                        }
                    </div>
                </div>
            </Label>
        )
    }

    useEffect(() => {
        if(checkValidation){
            setCheckValidation(false)
        }
    }, [checkValidation])

    return (
        <>
            <FormGroup>
                <Row>
                    <Col>
                        <Row>
                            <Col>
                                {renderLabel('periode', 'Periode')}
                                {/* <Input
                                    innerRef    = {register()}
                                    name        = "periode"
                                    type        = "month"
                                /> */}
                                <SelectPeriode 
                                    periode_context     = {periode_context}
                                    set_periode_context = {set_periode_context}
                                />
                            </Col>
                            <Col>
                                {renderLabel('tanggal_apel', 'Tanggal Apel')}
                                <Input
                                    innerRef    = {register()}
                                    name        = "tanggal_apel"
                                    type        = "date"
                                />
                            </Col>
                        </Row>
                    </Col>

                    {console.log("PENGUCAPTRIKRAMA", pengucap)}
                    <Col>
                        {renderLabel('nomor', 'Nomor')}
                        <Input
                            innerRef            = {register()}
                            name                = "nomor"
                        />
                    </Col>
                </Row>
            </FormGroup>
            
            {renderLabel('pengucap', 'Data Pengucap')}
            <TerlaporPelaporApi
                title           ="Pengucap"
                setSelectedEds  ={(eds) => {
                    set_pengucap(eds)
                }}
                hideWorkunit    = {true}
                isErrorValidation = {validation?.pengucap == false}
            />

            <FormGroup>
                <Row>
                    <Col>
                        {renderLabel('jumlah_pegawai', 'Jumlah Pegawai')}
                        <Input
                            innerRef    = {register()}
                            name        = "jumlah_pegawai"
                            type        = "number"
                        />
                    </Col>
                    <Col>
                        {renderLabel('jumlah_peserta', 'Jumlah Peserta Apel')}
                        <Input
                            innerRef    = {register()}
                            name        = "jumlah_peserta"
                            type        = "number"
                        />
                    </Col>
                </Row>
            </FormGroup>

            <FormGroup>
                <Row>
                    <Col>
                        {renderLabel('data_pendukung', 'Data Pendukung')}
                        <ListGroup className="mb-1">
                            {
                                lampiranNew.length > 0 ? (
                                    lampiranNew.map((item) => {
                                        return (
                                            <ListGroupItem>
                                                <div className="d-flex justify-content-between">
                                                    {item.name}
                                                    <Button color="primary" size="sm" onClick={() => removeLampiranNew(item)}>
                                                        Hapus
                                                    </Button>
                                                </div>
                                            </ListGroupItem>
                                        )
                                    })
                                ) : null
                            }
                        </ListGroup>
                        <Input
                            innerRef    = {register()}
                            name        = "data_pendukung"
                            type        = "file"
                            onChange    = {(e) => {
                                addLampiranNew(e.target.files)
                            }}
                        />
                    </Col>
                </Row>
            </FormGroup>

            <ButtonComponent
                routeBack       = {props.onBack}
                onNihilClick    = {onSubmitNihil}
                onSaveClick     = {onSubmit}
                loading         = {isClickedSubmit}
            />
        </>
    )
}

export { FormTriKrama }